import { DeliveryAddress } from './deliveryaddress';
import { Product } from './product';

export class OrderSummary{
    product:Product;
    pincode:any;
    deliveryAddress:DeliveryAddress;
}